import {
  computed,
  Inject,
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { IHeader } from '@web/dtos';
import { AppConfigService } from '../../app-config.service';
import { PREVIEW_TOKEN } from '../../../constants/injectionTokens.constant';

@Injectable({
  providedIn: 'root',
})
export class MockHeaderStore {
  private readonly configService: AppConfigService = inject(AppConfigService);

  constructor(@Inject(PREVIEW_TOKEN) private readonly previewData: IHeader) {}

  readonly isLoading: Signal<boolean> = signal(false);
  readonly header: WritableSignal<IHeader> = signal(this.previewData);

  updateHeader(query: IHeader): void {
    this.header.set(query);
  }

  save(query: IHeader): void {}

  logoPath: Signal<string> = computed((): string => {
    return (
      this.configService.get().general.cmsUrl +
      '/images/' +
      this.header().logo.image?.id
    );
  });
  rightPath: Signal<string> = computed((): string => {
    return (
      this.configService.get().general.cmsUrl +
      '/images/' +
      this.header().rightImage.image?.id
    );
  });
  leftPath: Signal<string> = computed((): string => {
    return (
      this.configService.get().general.cmsUrl +
      '/images/' +
      this.header().leftImage.image?.id
    );
  });
}
